import { FC, PropsWithChildren } from "react";
import { Size } from "@/types";
import { Button } from "../Button";
import { getDataAutomationId, getDataLinkAttributes } from "@/helpers";
import { Disclosure, DisclosureButton } from "@headlessui/react";
import cn from "classnames";

export type ExpandableBlockProps = {
  isOpen?: boolean;
  showDivider?: boolean;
  button?: {
    viewMore?: string;
    viewLess?: string;
    dld?: string;
    dlt?: string;
    size?: Size;
    automationId?: string;
    styleOverride?: string;
  };
};

export const ExpandableBlock: FC<PropsWithChildren<ExpandableBlockProps>> = ({
  isOpen,
  showDivider,
  button,
  children,
}) => {
  return (
    <Disclosure defaultOpen={isOpen}>
      {({ open }) => (
        <>
          <div
            className={cn(
              "mb-8 overflow-hidden transition-[max-height] duration-1000 ease-in-out",
              open ? "max-h-screen" : "max-h-0",
            )}
            inert={!open}
            aria-hidden={!open}
          >
            {children}
          </div>
          <DisclosureButton as="div">
            <Button
              variant="tertiary"
              icon={open ? "arrowUp" : "arrowDown"}
              iconPosition="right"
              className={cn(
                button?.styleOverride ||
                  "flex w-full flex-row justify-center pt-8",
                showDivider && "border-swdc-silver-200 border-t-2",
              )}
              size={button?.size}
              {...getDataLinkAttributes({ dlt: button?.dlt, dld: button?.dld })}
              {...getDataAutomationId(
                button?.automationId || "expandable-block-button",
              )}
            >
              {open ? button?.viewLess : button?.viewMore}
            </Button>
          </DisclosureButton>
        </>
      )}
    </Disclosure>
  );
};

export default ExpandableBlock;
